import { CHANNEL_COLORS, PROGRAM_COLORS } from "../../DeflectAnalyticsPage/utils/vocabulary"

// The platform's series colours — the merchant Deflect channels and programs, so a series reads the
// same on both pages (DAA-1-23) — and @Neutral300 for every channel outside the billable three.
export const SERIES_COLORS = { ...CHANNEL_COLORS, other: "#D0D0D4", ...PROGRAM_COLORS }
